import { EDIT_CAMPAIGN, EDIT_CAMPAIGN_SUCCESS, EDIT_CAMPAIGN_ERROR, EDIT_CAMPAIGN_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const EditCampaign = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_CAMPAIGN:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case EDIT_CAMPAIGN_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case EDIT_CAMPAIGN_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case EDIT_CAMPAIGN_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default EditCampaign;
